import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "services/principal/customFetchBase";

export const cicloApi = createApi({
  reducerPath: "cicloApi",
  baseQuery: customFetchBase,
  tagTypes: ["Ciclo"],
  endpoints: () => ({}),
});
